import React from 'react';
import TierPromotionCardSemiDumb from '../../../DeviationViews/TierPromotionCardEditorDumb';
import s from './Tier.scss';
const TierInlineView = (props)=>{
    const { deviation, width, height } = props;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, {
        width: width,
        height: height,
        deviation: deviation,
        ctaButton: "subscribe"
    }));
};
TierInlineView.displayName = 'TierInlineView';
export default TierInlineView;

//# sourceMappingURL=Tier.js.map